module.exports = __webpack_public_path__ + "fonts/40115d96-2de2-43ce-a50f-5baba79381b2.7bf90cc2.eot";